export default __webpack_public_path__ + "static/media/file_pdf_32.cb4b0671.svg";